export const setCurrentWins = (newWins, backButtonContent) => {
    const winsCookie = useCookie('currentWins');
    winsCookie.value = newWins;

    const backButtonCookie = useCookie('backButton');
    backButtonCookie.value = backButtonContent;
};

export const clearCurrentWins = () => {
    const winsCookie = useCookie('currentWins');
    winsCookie.value = null;

    const backButtonCookie = useCookie('backButton');
    backButtonCookie.value = null;
};
